import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { selectIsBowlingRestaurant } from "../../store/setupApi";
import "./css/terms-consent-modal.css";

const TermsConsentModal = ({
  open,
  onAgree,
  onDisagree,
  termsUrl = "https://voorwaarden.happychef.be/",
  title = "Algemene voorwaarden",
  agreeLabel = "Akkoord",
  disagreeLabel = "Niet akkoord",
}) => {
  const isBowling = useSelector(selectIsBowlingRestaurant);
  const iframeRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    // Prevent background scroll when modal is open
    const original = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = original);
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="terms-modal-backdrop"
      role="dialog"
      aria-modal="true"
      aria-label={title}
    >
      <div className="terms-modal">
        <div className="terms-modal__header">
          <img
            src={isBowling ? "https://static.reservaties.net/images/logo/HappyBowlingFinal.png" : "https://static.reservaties.net/images/logo/HappyChef-black-accent.png"}
            alt={isBowling ? "HappyBowling" : "HappyChef"}
            className="terms-modal__logo"
          />
          <h3 className="terms-modal__title">{title}</h3>
        </div>
        <div className="terms-modal__content">
          <iframe
            ref={iframeRef}
            src={termsUrl}
            title="Voorwaarden"
            className="terms-modal__iframe"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          />
        </div>
        <div className="terms-modal__footer">
          <button
            className="terms-btn terms-btn--secondary"
            onClick={onDisagree}
          >
            {disagreeLabel}
          </button>
          <button className="terms-btn terms-btn--primary" onClick={onAgree}>
            {agreeLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsConsentModal;
